/**
 * Plugin to preload image sequence frames before page render
 * This ensures the first frames are ready when components mount
 */
export default defineNuxtPlugin({
	name: 'image-sequence-preload',
	enforce: 'pre', // Run before other plugins
	async setup() {
		// Only run on client
		if (import.meta.server) return

		// Don't preload on mobile (uses video instead)
		if (window.innerWidth < 992) return

		// Define sequences to preload
		const sequences = [
			{
				name: 'about',
				getPath: (i: number) => `/images/freq/about/about_${String(i + 1).padStart(4, '0')}.jpg`,
				count: 5, // Preload first 5 frames
			},
			{
				name: 'advantages',
				getPath: (i: number) => `/images/freq/adv/adv_${String(i + 1).padStart(4, '0')}.jpg`,
				count: 5, // Preload first 5 frames
			},
		]

		// Preload in parallel
		const preloadPromises = sequences.flatMap((seq) =>
			Array.from({ length: seq.count }, (_, i) => {
				return new Promise<void>((resolve) => {
					const img = new Image()
					img.onload = () => resolve()
					img.onerror = () => resolve() // Don't block on errors
					img.src = seq.getPath(i)
				})
			})
		)

		// Wait for all preloads (with timeout)
		await Promise.race([
			Promise.all(preloadPromises),
			new Promise((resolve) => setTimeout(resolve, 3000)), // 3s timeout
		])
	},
})
